import { useEffect, useState } from "react";
import { Menu, X, Clock, ArrowRight } from "lucide-react";
import { NAV_LINKS } from "../../lib/constants";
import { trackEvent } from "../../lib/api";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 100);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const goToQuote = () => {
    trackEvent("cta_quote_click", { location: "navbar" });
    scrollTo("cotiza");
  };

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#FAFAF7]/95 backdrop-blur-md border-b-2 border-accent shadow-sm"
          : "bg-[#FAFAF7]/85 backdrop-blur-sm border-b border-[#DDE2D5]"
      }`}
    >
      <div className="container-tight flex items-center justify-between h-20">
        <a
          href="#top"
          onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: "smooth" }); }}
          className="flex items-center gap-3"
          data-testid="navbar-logo"
        >
          <img
            src="/images/brand/vt_logo_lightbg.png"
            alt="Velarias Tens"
            className="h-10 md:h-11 w-auto"
          />
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV_LINKS.map((l) => (
            <button
              key={l.id}
              onClick={() => scrollTo(l.id)}
              data-testid={`nav-link-${l.id}`}
              className="font-mono text-xs uppercase tracking-[0.2em] text-[#1F2937] hover:text-[#3D5311] transition-colors"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <span
            className="hidden md:inline-flex items-center gap-2 px-3 py-2 border border-accent text-[#3D5311] bg-[#F0F4DC] font-mono text-[10px] uppercase tracking-widest rounded-full"
            data-testid="navbar-trust-badge"
          >
            <Clock className="w-3 h-3 text-[#3D5311]" /> Respuesta en &lt; 24 h
          </span>
          <button
            onClick={goToQuote}
            className="group inline-flex items-center gap-2 btn-accent py-3 px-5 text-xs"
            data-testid="navbar-cta-quote"
          >
            Cotiza gratis
            <ArrowRight className="w-3.5 h-3.5 transition-transform group-hover:translate-x-1" />
          </button>
          <button
            className="lg:hidden p-2 text-[#1F2937]"
            onClick={() => setOpen((v) => !v)}
            aria-label="Menú"
            data-testid="navbar-menu-toggle"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-[#DDE2D5] bg-[#FAFAF7]/98 backdrop-blur-md" data-testid="navbar-mobile-menu">
          <div className="container-tight py-6 flex flex-col gap-5">
            {NAV_LINKS.map((l) => (
              <button
                key={l.id}
                onClick={() => scrollTo(l.id)}
                className="text-left font-display font-bold text-lg text-[#1F2937] hover:text-[#3D5311]"
                data-testid={`nav-mobile-link-${l.id}`}
              >
                {l.label}
              </button>
            ))}
            <span className="inline-flex items-center gap-2 px-3 py-2 border border-accent text-[#3D5311] bg-[#F0F4DC] font-mono text-[10px] uppercase tracking-widest w-fit rounded-full">
              <Clock className="w-3 h-3 text-[#3D5311]" /> Respuesta en &lt; 24 h
            </span>
            <button
              onClick={goToQuote}
              className="btn-accent justify-center"
            >
              Cotiza gratis
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
